<div class="card p-4">
<div class="p-field p-col-12">
  <h4>Buscar Formulas</h4>
  <a (click)="toggleShow()" *ngIf="!isShown" class="text-info">Búsqueda avanzada <span
      class="pi pi-angle-double-down"></span></a>

  <a (click)="toggleShow()" *ngIf="isShown" class="text-info">Búsqueda simple <span
      class="pi pi-angle-double-up"></span></a>
  |
  <a (click)="limpiar()" class="text-info">Limpiar <span class="pi pi-times"></span></a>
</div>

<div class="p-fluid p-grid p-nogutter">
  <div class="p-field p-col-12 p-md-3">
    <span class="p-float-label">
      <input
        type="text"
        id="inputtextcodigo"
        autocomplete="off"
        pInputText
        [(ngModel)]="codigo"
        (ngModelChange)="resetBusqueda()"
        />
      <label for="inputtextcodigo">Código de color</label>
    </span>
  </div>

  <div class="p-field p-col-12 p-md-3">
    <span class="p-float-label">
      <input
        type="text"
        id="chips"
        autocomplete="off"
        pInputText
        [(ngModel)]="chip"
        (ngModelChange)="resetBusqueda()"
        />
      <label for="chips">Chip</label>
    </span>
  </div>

  <div class="p-field p-col-12 p-md-3">
    <span class="p-float-label">
      <p-dropdown
        inputId="dropdownFabricante"
        [autoDisplayFirst]="false"
        [options]="fabricantes"
        [(ngModel)]="fabricante"
        [filter]="true"
        [showClear]="true"
        optionLabel="nombre"
        (ngModelChange)="resetBusqueda()"
        ></p-dropdown>
      <label for="dropdownFabricante">Fabricante</label>
    </span>
  </div>

  <div class="p-field p-col-12 p-md-3">
    <span class="p-float-label">
      <p-dropdown
        inputId="dropdownSistema"
        [autoDisplayFirst]="false"
        [options]="sistemas"
        [(ngModel)]="sistema"
        [filter]="true"
        [showClear]="true"
        optionLabel="nombre"
        (ngModelChange)="resetBusqueda()"
        ></p-dropdown>
      <label for="dropdownSistema">Sistema</label>
    </span>
  </div>

  <div class="p-field p-col-12 p-md-3">
    <span class="p-float-label">
      <input
        type="text"
        id="inputtextidformula"
        autocomplete="off"
        pInputText
        [(ngModel)]="idformula"
        (ngModelChange)="resetBusqueda()"
        />
      <label for="inputtextidformula">Id de formula</label>
    </span>
  </div>

  <div class="p-field p-col-12 p-md-3">
    <span class="p-float-label">
      <p-dropdown
        inputId="dropdownActivo"
        [autoDisplayFirst]="true"
        [options]="valoresActivos"
        [(ngModel)]="estadoFormula"
        optionLabel="nombre"
        (ngModelChange)="resetBusqueda()"
        ></p-dropdown>
      <label for="dropdownActivo">Estado</label>
    </span>
  </div>

  <div *ngIf="isShown" class="p-field p-col-12 p-md-3">
    <span class="p-float-label">
      <input
        type="text"
        id="inputtextcolor"
        autocomplete="off"
        pInputText
        [(ngModel)]="nombre"
        (ngModelChange)="resetBusqueda()"
        />
      <label for="inputtextcolor">Nombre de Color</label>
    </span>
  </div>

  <!--div class="p-field p-col-6 p-md-2">
    <p-button label="Limpiar" icon="pi pi-times" iconPos="right"></p-button>
  </div-->
  <div class="p-field p-col-12 p-md-3">
    <p-button
      (click)="buscar()"
      label="Buscar"
      [loading]="isLoading"
      icon="pi pi-search"
      iconPos="right"></p-button>
  </div>
</div>

<!--div class="d-flex justify-content-center">
  <div class="">
    <p-button label="Buscar" icon="pi pi-search"></p-button>
  </div>
</div-->

<p-table
  [value]="colorStore.formulas$ | async"
  [rowHover]="true"
  styleClass="p-datatable-sm p-datatable-striped p-datatable-responsive-demo"
  *ngIf="colorStore?.formulas?.length"
  [paginator]="true"
  [rows]="25"
  [alwaysShowPaginator]="false">
  <ng-template pTemplate="header">
    <tr>
      <th>Sistema</th>
      <th>Fabricante / Código</th>
      <th>Nombre</th>
      <th>Tipo</th>
      <th>Chip</th>
      <th>Formula</th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-color>
    <tr
      routerLink="/formulacolor/{{ color.pk.idsistema }}/{{ color.pk.idformula }}/{{ color.pk.idcolor }}">
      <td>
        {{ color.sistema }}
      </td>
      <td>{{ color.fabricante + " - " + color.codigocolor }}</td>
      <td>
        <a
          routerLink="/formulacolor/{{ color.pk.idsistema }}/{{ color.pk.idformula }}/{{ color.pk.idcolor }}"
          class="link-primary">
          {{ color.nombrecolor }}
        </a>
      </td>
      <td>
        {{ color.tipocolor }}
      </td>
      <td>
        {{ color.chip }}
      </td>
      <td>
        {{ color.pk.idformula }} 
      </td>
      <td>
        <p-button icon="pi pi-pencil" pTooltip="Editar fórmula"
         *ngIf="esAdmin"
         (onClick)="iraFormula(color)"
          styleClass="p-button-rounded p-button-text"></p-button>
      </td>
    </tr>
  </ng-template>
</p-table>

<div *ngIf="!notificada && busquedaIniciada && colorStore.formulas.length==0" class="text-center">

  <p class="text-primary">Formulas no encontradas. Notifique que no se encontraron resultados con los datos ingresados:
 </p>
  <p-button icon ="pi pi-send" label="Notificar" styleClass="p-button-raised p-button-text"
  (click)="notificarFormulasNoEncontradas()"
  ></p-button>

</div>

<p-confirmDialog #cd [style]="{width: '50vw'}" >
  <ng-template pTemplate="header">
    <h3>No se encontraron resultados</h3>
  </ng-template>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="pi pi-envelope" label="Notificar" (click)="cd.accept()"></button>
    <button type="button" pButton class="p-button-secondary" icon="pi pi-times" label="Cerrar" (click)="cd.reject()"></button>
  </ng-template>
</p-confirmDialog>
</div>